export default "__VITE_ASSET__EUEFu79o__"